// hooks/usePreloadImages.js
import { useEffect } from 'react';

export const usePreloadImages = (questions = []) => {
  useEffect(() => {
    if (!questions.length) return;
    const urls = questions.flatMap(q => q.options.map(o => o.imageUrl));

    urls.forEach(src => {
      const img = new Image();
      img.decoding = 'async';   // evita el thread principal
      img.src = src;            // el bitmap queda en la HTTP cache
    });
  }, [questions]);
}
